"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericActiveAnnotationCode = exports.genericIrisPreCaptureAnnotations = exports.genericPalmprintPreCaptureAnnotations = exports.genericFingerprintPreCaptureAnnotations = exports.GenericAnnotationCodes = void 0;
var GenericAnnotationCodes;
(function (GenericAnnotationCodes) {
    GenericAnnotationCodes["Active"] = "active";
    GenericAnnotationCodes["Amputation"] = "XX";
    GenericAnnotationCodes["UnableToPrint"] = "UP";
    GenericAnnotationCodes["Missing"] = "MA";
    GenericAnnotationCodes["UnableToCapture"] = "UC";
})(GenericAnnotationCodes = exports.GenericAnnotationCodes || (exports.GenericAnnotationCodes = {}));
exports.genericFingerprintPreCaptureAnnotations = [
    { label: 'Amputation', code: GenericAnnotationCodes.Amputation, isEntryDisabled: true },
    { label: 'Unable to Print', code: GenericAnnotationCodes.UnableToPrint },
    { label: 'None', code: GenericAnnotationCodes.Active }
];
exports.genericPalmprintPreCaptureAnnotations = [
    { label: 'Amputation', code: GenericAnnotationCodes.Amputation, isEntryDisabled: true },
    { label: 'Unable to Print', code: GenericAnnotationCodes.UnableToPrint },
    { label: 'Active', code: GenericAnnotationCodes.Active }
];
exports.genericIrisPreCaptureAnnotations = [
    { label: 'Missing', code: GenericAnnotationCodes.Missing, isEntryDisabled: true },
    { label: 'Unable to Capture', code: GenericAnnotationCodes.UnableToCapture },
    { label: 'None', code: GenericAnnotationCodes.Active }
];
exports.genericActiveAnnotationCode = GenericAnnotationCodes.Active;
//# sourceMappingURL=genericCaptureAnnotations.js.map